import { Checkbox, Divider, Radio, RadioGroup } from 'rsuite';
import styles from './PreferencesForm.module.scss';

type PreferencesFormProps = {
  priceType: string;
  onChangePriceType: (value: string) => void;
  physicalChannel: boolean;
  onChangePhysicalChannel: (checked: boolean) => void;
  digitalChannel: boolean;
  onChangeDigitalChannel: (checked: boolean) => void;
  hideHeader?: boolean;
};

export const PreferencesForm = ({
  priceType,
  onChangePriceType,
  physicalChannel,
  onChangePhysicalChannel,
  digitalChannel,
  onChangeDigitalChannel,
  hideHeader = false,
}: PreferencesFormProps) => {
  return (
    <div className={hideHeader ? styles.containerFlat : styles.container}>
      {!hideHeader && (
        <div className={styles.header}>
          <h2 className={styles.title}>Preferências</h2>
          <p className={styles.subtitle}>Selecione as preferências como tipo de preço e canal</p>
        </div>
      )}

      <div className={styles.section}>
        <p className={styles.sectionTitle}>TIPO DE PREÇO</p>
        <RadioGroup name="priceType" value={priceType} onChange={onChangePriceType} className={styles.radioGroup}>
          <Radio value="PAGO" className={styles.radioItem}>
            <div className={styles.radioContent}>
              <p className={styles.radioTitle}>Preço pago</p>
              <p className={styles.radioSubtitle}>Preço efetivamente pago pelo consumidor no varejo, podendo ser promoção.</p>
            </div>
          </Radio>
          <Radio value="REGULAR" className={styles.radioItem}>
            <div className={styles.radioContent}>
              <p className={styles.radioTitle}>Preço regular</p>
              <p className={styles.radioSubtitle}>Preço original do produto, sem promoção e outros descontos.</p>
            </div>
          </Radio>
        </RadioGroup>
      </div>

      <Divider className={styles.divider} />

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <p className={styles.sectionTitle}>CANAL</p>
          <p className={styles.sectionSubtitle}>Selecione ao menos uma opção</p>
        </div>
        <div className={styles.checkboxGroup}>
          <Checkbox checked={physicalChannel} onChange={(_, checked) => onChangePhysicalChannel(checked)} className={styles.checkboxItem}>
            <div className={styles.radioContent}>
              <p className={styles.radioTitle}>Canal físico</p>
              <p className={styles.radioSubtitle}>
                Preços praticados na loja física. Coletados diretamente do ponto de venda, de notas fiscais ou de apps quando correspondem aos preços da loja.
              </p>
            </div>
          </Checkbox>
          <Checkbox checked={digitalChannel} onChange={(_, checked) => onChangeDigitalChannel(checked)} className={styles.checkboxItem}>
            <div className={styles.radioContent}>
              <p className={styles.radioTitle}>Canal digital</p>
              <p className={styles.radioSubtitle}>Preços praticados em sites/apps do varejo físico (iFood, Rappi, etc.).</p>
            </div>
          </Checkbox>
        </div>
      </div>
    </div>
  );
};
